import React, {Component} from 'react';
import BaseComponent from "../../../../base/BaseComponent";
import SwitchBounced from "../switchBounced/SwitchBounced";
import Concurrently from "../concurrently/Concurrently";
import CmForm from "../../../../components/CmForm/CmForm";
import ImgUpload from "../../../sysManagement/paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
import {Icon, Input, Modal, Form, Radio, message} from 'antd'
import MeanwhilePublishTitlePic from "../../rmAppEditor/MeanwhilePublishTitlePic";
import {systemBaseEvent} from "../../../../base/baseEvent";

const FormItem = Form.Item;

const publishSettings = {
//栏目信息
    programaKey: 'programaFtitle',//栏目信息数据保存标题key
    programaName: '栏目',//栏目信息标题名称
//当前栏目信息
    currentColumnKey: 'currentColumnFtitle',//当前栏目信息数据保存标题key
    currentColumnName: '当前栏目',//当前栏目信息标题名称
    headlinesPlaceholder: '这是一个栏目名称',//栏目名称的提示
    currentColumnIsRequest: true,//是否必输项，
    currentColumnCheckMessage: '请选择当前栏目',
};
class RmSelectColumn extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            columnDown: true,//页面展开
            publishInformation: {
                mainColumn: {},//当前栏目
                deliveryNews: [],//同步发布栏目
            },
            columnTree: [],// 媒体栏目树
            visibleSetting:false,//栏目设置弹窗
            concurrentColumnItem: {},// 同步发布栏目（当前设置项）
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getColumnTree();
        // 监听发布账号改变
        systemBaseEvent.registerBaseEvent("publishAccountChange", ({res})=>{
            this.getMeanwhilePublishColumn(res);
        });
    }

    getData = () => {
        let {publishInformation} = this.state;
        return publishInformation
    };

    setData = ({deliveryNews,mainColumn,callBack}) => {
        this.state.publishInformation.deliveryNews = deliveryNews && deliveryNews.length ? deliveryNews.map(item=>{
            if(!item.key){
                let key = item.columnId;
                return {...item,key}
            } else {
                return item
            }
        }) : [];
        this.setState({},()=>{if(callBack){
            callBack()
        }});
        if(mainColumn) {
            let type = this.props.dynamicParams?.editorId ? 'onlyShow' : '';
            this.setMainColumn(mainColumn, type)
        }
    };

    // 获取栏目树
    getColumnTree = () => {
        this.request({
            url: "/cm-sites-pms/columnSync/getColumnTreeByUserAuth",
            body: {mediaType: "rmapp"},
            callBack: (res) => {
                let columnTree = [];
                let addAttr = (tree) => {
                    if (tree) {
                        tree.bindVsbUser = true;
                        tree.key = tree.treeId || tree.key;
                        if (tree.subColumnTree && tree.subColumnTree.length > 0) {
                            tree.subtree = tree.subColumnTree;
                            tree.subColumnTree.map(item => {
                                addAttr(item);
                            })
                        }
                    }
                };
                if (res && res.length) {
                    res.forEach(item => {
                        addAttr(item);
                    })
                    columnTree = res;
                }
                this.setState({columnTree})
            },
            errorCallBack: (e) => {
            }
        })
    };
    // 回显主栏目
    setMainColumn = (res, type) => {
        let mainColumn = {};
        if (res) {
            mainColumn = res;
            mainColumn.key = mainColumn.columnId || mainColumn.treeId;
            mainColumn.id = mainColumn.columnId || mainColumn.treeId;
        }
        this.handleOk(mainColumn, type);
    };

    render() {
        return (
            <div style={{padding: "0px 10px"}}>
                <div className={"topLine"}/>
                {/*tab*/}
                {this.renderTab()}
                {/*当前栏目*/}
                {this.renderPresentColumn()}
                {/*同时发布栏目*/}
                {this.renderConcurrentColumn()}
            </div>
        )
    }

    renderTab = () => {
        const {columnDown} = this.state;
        return (
            <div style={{display: 'flex',justifyContent: 'space-between',marginTop: '10px',}}>
                <div style={{fontWeight: 'bold'}}>{publishSettings.programaName}</div>
                <div><Icon type={columnDown ? "down" : "up"} onClick={this.arrowTransform}/>
                </div>
            </div>
        )
    };
    // 当前栏目
    renderPresentColumn = () => {
        const {publishInformation, columnDown, columnTree} = this.state;
        let mainNode = this.state.publishInformation.deliveryNews;
        return (
            <div style={{
                display: columnDown ? 'flex' : 'none',
                justifyContent: 'space-between',
                marginTop: '10px',
            }}>
                <div style={{lineHeight: '32px'}}>{publishSettings.currentColumnName}</div>
                <Input style={{fontSize: '12px', width: '135px', height: '32px',}}
                       value={publishInformation.mainColumn.title || publishInformation.mainColumn.columnName}
                       placeholder={publishSettings.headlinesPlaceholder}
                       onClick={() => {
                           let checkedKeys = this.state.publishInformation.mainColumn.key ?
                               [this.state.publishInformation.mainColumn.key]
                               : [];
                           this.switchBounced.show();
                           this.switchBounced.onSetCheckedKeys(checkedKeys, this.state.publishInformation.mainColumn);
                       }}
                />
                <div style={{lineHeight: '32px', cursor: 'pointer'}} onClick={() => {
                    let checkedKeys = this.state.publishInformation.mainColumn.key ?
                        [this.state.publishInformation.mainColumn.key]
                        : [];
                    this.switchBounced.show();
                    this.switchBounced.onSetCheckedKeys(checkedKeys,this.state.publishInformation.mainColumn);
                }}>{publishInformation&&publishInformation.mainColumn&&publishInformation.mainColumn.contentName?'切换':'选择'}
                </div>
                <SwitchBounced
                    ref={(ref)=>this.switchBounced=ref}
                    handleOk={data => this.handleOk(data)}
                    hideNode={mainNode}
                    hideNodeAttr={"key"}
                    treeData={columnTree}
                />
            </div>
        )
    };
    setShowTit = (title) => {
        return title
    };
    // 同时发布栏目
    renderConcurrentColumn = () => {
        let {publishInformation, columnTree, columnDown} = this.state;
        let {deliveryNews = []} = publishInformation;
        let concurrentColumnLength = (deliveryNews && deliveryNews.length) || 0;
        let checkedKeys = deliveryNews.length ? deliveryNews.map(item =>item.key) : [];
        let mainNode = this.state.publishInformation.mainColumn;
        return (
            <>
                <div style={{display: columnDown?'flex':'none',justifyContent: 'space-between',marginTop: '10px'}}>
                    <div style={{minWidth: "min-content", maxWidth: "120px", height: 16}}>同时发布到({concurrentColumnLength})</div>
                    <div><Icon style={{lineHeight: '20px'}} type="plus" onClick={()=>{
                        this.concurrently.show();
                        this.concurrently.onSetCheckedKeys(checkedKeys, deliveryNews);
                    }}/></div>
                    <Concurrently
                        ref={(ref)=>this.concurrently = ref}
                        hideNode={mainNode}
                        hideNodeAttr={"key"}
                        handleOk={checkedNodes => this.concurrentlyOk(checkedNodes)}
                        treeData={columnTree}
                        hideChoose={true}
                    />
                </div>
                <div style={{display:concurrentColumnLength&&columnDown?'block':'none',
                    backgroundColor: '#F6F8FD',
                    marginTop: '10px',
                    padding:'6px 2px 6px 10px',
                    // width: 240,
                    background: '#F6F8FD',
                    border: '1px solid #EEF2FB',
                    opacity: 1,
                    borderRadius: '5px',
                }}>
                    {concurrentColumnLength ? deliveryNews.map((item, index) => {
                        let title = this.getColumnTitle(item);
                        let showTit = this.setShowTit(title);
                        return (
                            <div key={index}
                                 style={{display: 'flex', justifyContent: 'space-between', height: 'auto', padding: 6}}>
                                <div style={{lineHeight: '20px'}}>
                                    <Icon style={{color: this.themeBgColor}}
                                          type={"file-text"}/>
                                </div>
                                <div title={title} style={{
                                    flex: 1,
                                    marginLeft: 4,
                                    width: 120,
                                    overflowWrap: "break-word",
                                }}
                                >{showTit}</div>
                                <div style={{marginLeft: 4, display: item.titlePic ? 'block' : 'none'}}>
                                    <Icon type="picture"/>
                                </div>
                                <div style={{marginLeft: 4, display: parseInt(item.top) ? 'block' : 'none'}}>
                                    <Icon type="vertical-align-top"/>
                                </div>
                                {!this.props.hideMeanwhilePublishSet ?
                                    <div
                                        onClick={() => {
                                            this.showSettingModal(item)
                                        }}
                                        style={{color: this.themeBgColor, cursor: "pointer", padding: "0px 5px"}}>设置
                                    </div> : null}
                                {!this.props.hideMeanwhilePublishMove ?
                                    <div
                                        onClick={() => {
                                            deliveryNews.splice(index, 1);
                                            this.setState({})
                                        }}
                                        style={{color: this.themeBgColor, cursor: "pointer"}}>移除
                                    </div> : null}
                            </div>
                        )
                    }) : ''}
                </div>
                {/*点击设置的弹窗*/}
                {this.renderSettingModal()}
            </>
        )
    };

    getColumnTitle(data) {
        let title = "";
        if(data.mediaName) {
            title += data.mediaName
        }
        if(data.title || data.columnName) {
            title += `/${data.title || data.columnName}`
        }
        return title;
    };

    showSettingModal(concurrentColumnItem) {
        this.setState({concurrentColumnItem, visibleSetting:true})
    }

    renderSettingModal = () => {
        let {visibleSetting, concurrentColumnItem} = this.state;
        concurrentColumnItem.top =  this.setSelected(concurrentColumnItem.top * 1); // 设置默认值0
        concurrentColumnItem.recommend =  this.setSelected(concurrentColumnItem.recommend * 1); // 设置默认值0
        return (
            <Modal
                title={'栏目设置'}
                visible={visibleSetting}
                onCancel={()=>{this.setState({visibleSetting:false})}}
                onOk={this.saveSetting}
                destroyOnClose={true}
                width={610}
            >
                <CmForm>
                    <FormItem
                        label={'当前栏目'}
                        required={false}
                    >
                        <Input
                            disabled={true}
                            value={this.getColumnTitle(concurrentColumnItem)}
                        />
                    </FormItem>
                    {/*暂时屏蔽*/}
                    {/*<FormItem*/}
                    {/*    label={"设置置顶"}*/}
                    {/*    required={false}*/}
                    {/*>*/}
                    {/*    <Radio.Group*/}
                    {/*        onChange={e => this.onColumnChange({ top: e.target.value*1})}*/}
                    {/*        value={concurrentColumnItem.top}*/}
                    {/*    >*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*    </Radio.Group>*/}
                    {/*</FormItem>*/}
                    {/*<FormItem*/}
                    {/*    label={"设置推荐"}*/}
                    {/*    required={false}*/}
                    {/*>*/}
                    {/*    <Radio.Group*/}
                    {/*        onChange={e => this.onColumnChange({ recommend: e.target.value*1})}*/}
                    {/*        value={concurrentColumnItem.recommend}*/}
                    {/*    >*/}
                    {/*        <Radio value={1}>是</Radio>*/}
                    {/*        <Radio value={0}>否</Radio>*/}
                    {/*    </Radio.Group>*/}
                    {/*</FormItem>*/}
                    {!this.props.hideTitle && <FormItem
                        label={'设置标题图'}
                        required={false}
                    >
                        {/*<ImgUpload*/}
                        {/*    onChange={titlePic => this.onColumnChange({ titlePic })}*/}
                        {/*    defaultUpload={"editColumn"}*/}
                        {/*    value={concurrentColumnItem.titlePic}*/}
                        {/*/>*/}
                        <MeanwhilePublishTitlePic
                            selectByLocal={this.props.selectByLocal}
                            selectByLocalFunction={(callBack) => this.props.selectByLocalFunction(callBack)}
                            showSelectOperate={this.props.showSelectOperate}
                            showCutOperate={this.props.showCutOperate}
                            currentItem={concurrentColumnItem}
                            videoUrl={this.props.videoUrl}
                            ref={(meanwhilePublishTitlePic) => this.meanwhilePublishTitlePic = meanwhilePublishTitlePic}
                        />
                    </FormItem>}
                </CmForm>
            </Modal>
        )
    };

    setSelected = (num) => {
        if(num!==1) {
            return 0
        } else {
            return num
        }
    };

    onColumnChange(data) {
        let concurrentColumnItem = {...this.state.concurrentColumnItem,...data};
        this.setState({concurrentColumnItem},()=>{
        })
    }

    saveSetting = () => {
        let {concurrentColumnItem, publishInformation} = this.state;
        let {deliveryNews} = publishInformation;
        if(this.meanwhilePublishTitlePic) {
            let picData = this.meanwhilePublishTitlePic.getPicData();
            if(!picData) return;
            concurrentColumnItem = {...concurrentColumnItem, ...picData};
        }
        let index = deliveryNews.findIndex(item=>item.key===concurrentColumnItem.key);
        if(index>-1){
            this.state.publishInformation.deliveryNews[index] = concurrentColumnItem
        }
        this.setState({visibleSetting:false});
    };

    arrowTransform = () => {
        const {columnDown} = this.state;
        this.setState({
            columnDown: !columnDown,
        })
    };

    // 主栏目点击确认回调
    handleOk = (checkedNode, type) => {
        if(type !== 'onlyShow' && checkedNode && (checkedNode.columnId || checkedNode.treeId) && checkedNode.mediaId) {
            this.request({
                url: "/cm-sites-pms/columnSync/getColumnSync",
                body: {
                    treeId: checkedNode.columnId || checkedNode.treeId,
                    mediaId: checkedNode.mediaId
                },
                callBack: (res) => {
                    this.getMeanwhilePublishColumn(res);
                }
            });
            if(this.props.dynamicParams && typeof this.props.dynamicParams.setDynamicParams === "function") {
                // 重新选择主栏目后，需要重新加载表单模块
                this.props.dynamicParams.setDynamicParams({
                    mediaId: checkedNode.mediaId,
                    columnId: checkedNode.columnId || checkedNode.treeId,
                })
            }
        }
        this.state.publishInformation.mainColumn = checkedNode;
        this.setState({})
    };

    getMeanwhilePublishColumn(res) {
        // 赋值给副栏目
        let upDeliveryNews = this.state.publishInformation.deliveryNews;
        if (res && res.length) {
            let newDeliveryNews;
            newDeliveryNews = res.filter(item => !upDeliveryNews.some(child => child.columnId === item.bindTreeId));
            if (newDeliveryNews.length) {
                newDeliveryNews = newDeliveryNews.map(item=>({
                    columnId: item.bindTreeId,
                    columnName: item.bindTreeName,
                    mediaId: item.bindMediaId,
                    mediaName: item.bindMediaName,
                    deliveryWay: item.deliveryWay,
                }));
                upDeliveryNews = [...upDeliveryNews, ...newDeliveryNews]
            }
            this.setData({
                deliveryNews: upDeliveryNews, mainColumn: false, callBack: () => {
                    this.concurrentlyOk(this.state.publishInformation.deliveryNews)
                }
            })
        }
    }

    // 同步发布栏目点击确认回调
    concurrentlyOk = (checkedNodes) => {
        //同时发布无权限媒体栏目逻辑
        let newCheckedNodes = [...this.concurrently.filterNodes(this.state.publishInformation.deliveryNews), ...checkedNodes];
        checkedNodes = newCheckedNodes.filter((item, index) => {
            return newCheckedNodes.indexOf(item) === index;
        })
        let deliveryNews = [];
        if(checkedNodes && checkedNodes.length) {
            deliveryNews = checkedNodes.map(item=>({
                // 是否置顶 int
                top: 0,
                // 是否推荐 int
                recommend: 0,
                // 标题图
                titlePic: "",
                columnId: item.treeId,
                columnName: item.treeName,
                ...item,
            }))
        };
        this.state.publishInformation.deliveryNews=deliveryNews;
        this.setState({})
    };
}

export default RmSelectColumn;
